// register component(s) with react habitat

import TimelineSlider from './slider'

export default {
  TimelineSlider,
}
